export default __webpack_public_path__ + "static/media/danger-sign-delta.433d978c.svg";